import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const NotChecked = ({
  width = 24,
  height = 32,
  className,
  color,
  decorative = false,
  ariaLabel = "Not checked",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 32"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path fill="#fff" d="M0 0h24v32H0z"></path>
      <rect
        width="22"
        height="22"
        x="1"
        y="5"
        stroke="#5C6F82"
        strokeWidth="2"
        rx="11"
      ></rect>{" "}
    </svg>
  );
};


